import script from "./PurchaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseModal.vue?vue&type=style&index=0&id=8548eb2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8548eb2a"]])

export default __exports__